'use client';

import { useState } from 'react';
import { Sidebar } from './components/shared/Sidebar';
import { Header } from './components/shared/Header';
import { Dashboard } from './modules/dashboard';
import { POSModule } from './modules/pos';
import { StockModule } from './modules/stock';
import { SellingModule } from './modules/selling';
import { BuyingModule } from './modules/buying';
import { AccountsModule } from './modules/accounts';
import { ManufacturingModule } from './modules/manufacturing';
import { CRMModule } from './modules/crm';
import { ProjectsModule } from './modules/projects';
import type { ModuleId, User } from './types';

// 현재 사용자 (데모용)
const currentUser: User = {
  id: 'user-001',
  name: '홍길동',
  email: 'hong@example.com',
  role: 'admin',
  avatar: undefined,
};

export default function BoxERP() {
  const [currentModule, setCurrentModule] = useState<ModuleId>('dashboard');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // 모듈별 컴포넌트 렌더링
  const renderModule = () => {
    switch (currentModule) {
      case 'dashboard':
        return <Dashboard />;
      case 'pos':
        return <POSModule onBack={() => setCurrentModule('dashboard')} />;
      case 'stock':
        return <StockModule onBack={() => setCurrentModule('dashboard')} />;
      case 'selling':
        return <SellingModule onBack={() => setCurrentModule('dashboard')} />;
      case 'buying':
        return <BuyingModule onBack={() => setCurrentModule('dashboard')} />;
      case 'accounts':
        return <AccountsModule onBack={() => setCurrentModule('dashboard')} />;
      case 'manufacturing':
        return <ManufacturingModule onBack={() => setCurrentModule('dashboard')} />;
      case 'crm':
        return <CRMModule onBack={() => setCurrentModule('dashboard')} />;
      case 'projects':
        return <ProjectsModule onBack={() => setCurrentModule('dashboard')} />;
      case 'settings':
        return <ComingSoon module="설정" />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="relative flex h-screen bg-background overflow-hidden">
      {/* 사이드바 */}
      <Sidebar
        currentModule={currentModule}
        onModuleChange={setCurrentModule}
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileMenuOpen}
        onMobileClose={() => setMobileMenuOpen(false)}
      />

      {/* 메인 컨텐츠 */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* 헤더 */}
        <Header
          user={currentUser}
          onToggleSidebar={() => setMobileMenuOpen(!mobileMenuOpen)}
        />

        {/* 컨텐츠 영역 */}
        <main className="flex-1 overflow-auto p-3 sm:p-4 lg:p-6">
          {renderModule()}
        </main>
      </div>
    </div>
  );
}

// 준비 중 컴포넌트
function ComingSoon({ module }: { module: string }) {
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <div className="text-6xl mb-4">🚧</div>
        <h2 className="text-2xl font-bold text-foreground mb-2">{module}</h2>
        <p className="text-muted-foreground">이 모듈은 준비 중입니다.</p>
      </div>
    </div>
  );
}
